import baseApplicationItem from './baseApplicationItem'
import {merge} from 'lodash'

let module = {
  endpoint: 'admin/catalog',
  getNew: {
    id: null,
    code: null,
    deleted: false,
    products: []
  },
  tableInfo: {
    tableFields: [
      {
        name: '__component:badge-deleted-column',
        title: '',
        dataClass: 'text-center'
      },
      {
        name: '__checkbox',
        title: '',
        class: 'primary'
      },
      {
        name: 'id',
        title: 'id',
        sortField: 'id'
      },
      {
        name: 'code',
        title: 'codice',
        sortField: 'code'
      },
      {
        name: 'description',
        title: 'Descrizione',
        sortField: 'description'
      },
      {
        name: '__component:actions-column',
        title: '',
        dataClass: 'text-center'
      }
    ],
    sortFunctions: {
    }
  },
}

export default merge(module, baseApplicationItem)




// WEBPACK FOOTER //
// ./src/application/catalogs.js